"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSendingTypesGenerallyAvailable = void 0;
const shared_types_1 = require("@sigmasms/shared-types");
exports.CSendingTypesGenerallyAvailable = [
    shared_types_1.SendingTypes.sms,
    shared_types_1.SendingTypes.viber,
    shared_types_1.SendingTypes.vk,
    shared_types_1.SendingTypes.whatsapp,
    shared_types_1.SendingTypes.push,
    shared_types_1.SendingTypes.voice,
    shared_types_1.SendingTypes.flashcall,
    shared_types_1.SendingTypes.telegramcode
];
//# sourceMappingURL=sendings.const.js.map